import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import profile_av from "../../assets/images/profile_av.png";
import DynamicSidebar from "./Components/DynamicSidebar";

const CommonSidebar = ({ iconColor }) => {
  const user = useSelector((state) => state.auth.user);
  const userType = useSelector((state) => state.auth.userType);
  const hrmsUser = useSelector((state) => state.auth.hrmsUser);
  const permissions = useSelector((state) => state.auth.permissions);
  const { sidebarMenus = [] } = useSelector((state) => state.menu);
  const profileName = userType === "hrms" ? hrmsUser?.name : user?.user?.UserName;

  const profileDesignation = userType === "hrms" ? hrmsUser?.designation : null;

  const profileLink = userType === "hrms" ? "/hrms/my-profile" : "/manager/profile";

  const hasPermission = (code) => permissions?.includes(code);
  const location = useLocation();

  const filterMenusByPermission = (menus) => {
    return menus
      .filter((menu) => {

        if (!menu.vchPermissionCode) return true;
        return hasPermission(menu.vchPermissionCode);
      })
      .map((menu) => ({
        ...menu,
        children: menu.children ? filterMenusByPermission(menu.children) : [],
      }));
  };

  // Admin sees all menus, HRMS users see only permitted menus
  const filteredMenus = userType === "admin"
    ? sidebarMenus
    : filterMenusByPermission(sidebarMenus);

  const isModuleActive = (module) => {
    return module.children?.some(
      (m) => location.pathname.startsWith(m.vchPath)
    );
  };

  return (
    <aside
      className="ps-xl-5 ps-lg-4 ps-3 pe-2 py-3 sidebar sticky-top"
      id="sidebarDark"
      data-bs-theme="none"
    >
      <nav className="navbar navbar-expand-xl py-0">
        <div
          className="offcanvas offcanvas-start"
          data-bs-scroll="true"
          tabIndex="-1"
          id="offcanvas_Navbar"
        >

          <div className="offcanvas-header">
            <span className="fw-bold fs-5 text-gradient">JTDC</span>
            <button
              type="button"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>

          {/* SIDEBAR BODY */}
          <div className="offcanvas-body flex-column custom_scroll ps-4 ps-xl-0">
            <Link
              to={profileLink}
              className="d-flex align-items-center p-2 rounded mb-2 text-decoration-none"
              style={{ cursor: "pointer" }}
            >
              <img
                className="rounded-circle border border-1"
                src={profile_av}
                alt="avatar"
                style={{ height: "70px", width: "70px", objectFit: "contain" }}
              />

              {/* USER INFO */}
              <div className="ms-3">
                <h5 className="mb-1 fw-bold text-primary">
                  {profileName}
                </h5>
                {profileDesignation && (
                  <p className="mb-0 text-muted small">{profileDesignation}</p>
                )}
              </div>
            </Link>

            {/* Menu tab */}
            <ul
              className="nav nav-tabs tab-dynamic px-0 mb-4 d-flex flex-wrap overflow-auto"
              role="tablist"
              style={{ "--dynamic-color": "var(--accent-color)" }}
            >
              {filteredMenus.map((module, index) => (
                <li key={module.intMenuId} className="nav-item me-2">
                  <a
                    className={`nav-link ${isModuleActive(module) ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href={`#tab_${module.vchMenuName.toLowerCase()}`}
                  >
                    {module.vchMenuName.toUpperCase()}
                  </a>
                </li>
              ))}
            </ul>

            {/* Menu content */}
            <div className="tab-content mt-2">
              {filteredMenus.map((module, index) => {
                const isActive = index === 0;

                return (
                  <div
                    key={module.intMenuId}
                    className={`tab-pane fade ${isActive ? "show active" : ""}`}
                    id={`tab_${module.vchMenuName.toLowerCase()}`}
                    role="tabpanel"
                  >
                    <div className="sidebar-menu-wrapper">
                      <DynamicSidebar
                        menus={module.children}
                        iconColor={iconColor}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            {/* HRMS User Info Card */}
            {userType === "hrms" && (
              <div className="px-3 py-2">
                <div className="card bg-light">
                  <div className="card-body p-3">
                    <h6 className="card-title mb-2">{hrmsUser?.name}</h6>
                    <p className="card-text small mb-1">
                      <strong>ID:</strong> {hrmsUser?.employee_id}
                    </p>
                    <p className="card-text small mb-0">
                      <strong>Designation:</strong> {hrmsUser?.designation || 'N/A'}
                    </p>
                    <p className="card-text small mb-1">
                      <strong>Dept/Unit:</strong> {hrmsUser?.department || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </nav>
    </aside >
  );
};

export default CommonSidebar;
